import classNames from 'classnames';
import React from 'react';
import { TableCellType } from '../../ComparisonTableTypes.ts';
import { RowHeader } from '../../RowHeader/RowHeader.tsx';
import styles from './TableDesktopCell.module.scss';

export interface TableDesktopCellProps extends TableCellType {
  isHeader?: boolean;
  isRowHeader?: boolean;
}
export const TableDesktopCell: React.FC<TableDesktopCellProps> = (props) => {
  if (props.image) {
    return (
      <div className={styles.table_cell}>
        <div
          className={classNames(styles.image_cell, props.isHeader ? styles.header_image_cell : '')}
        >
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src={props.image.imageUrl}
            alt={props.image.altText}
            className={styles.standard_image}
            loading="lazy"
            fetchPriority="low"
            decoding="async"
          />
        </div>
        {props.helperText ? (
          <div
            dangerouslySetInnerHTML={{ __html: props.helperText || '' }}
            className={styles.helper_text}
          />
        ) : (
          <span
            className={!props.isHeader ? styles.helper_text_placeholder : ''}
            aria-hidden="true"
          />
        )}
      </div>
    );
  }
  return (
    <div className={styles.table_cell}>
      {/*isHeader checks if it is column header  */}
      {props.isHeader || !props.isRowHeader ? (
        <div
          dangerouslySetInnerHTML={{ __html: props.bodyText || '' }}
          className={props.isHeader ? styles.header_text : styles.cell_text}
        />
      ) : (
        //Text Cell
        <RowHeader title={props.title} bodyText={props.bodyText} cta={props.cta} />
      )}
    </div>
  );
};
